import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import tobaccoGaleraProductionApi from '../../../api/tobaccoGaleraProductionApi';

// ---------------------------------------------------------------------

interface ProductionParams {
  startDate: string;
  endDate: string;
}

const REDUCER_NAME = 'tobaccoGaleraProduction';

export const GetTobaccoGaleraProduction = createAsyncThunk(
  `${REDUCER_NAME}/getTobaccoGaleraProduction`,
  async (params: ProductionParams, thunkAPI) => {
    params.startDate = dayjs(params.startDate).format('YYYY-MM-DD');
    params.endDate = dayjs(params.endDate).format('YYYY-MM-DD');

    const res = await tobaccoGaleraProductionApi.get(params);

    if (res.status === 200) {
      return { ...res.data?.data, startDate: params.startDate, endDate: params.endDate };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
